import { Grid, Typography } from "@mui/material"
import useAuth from "../../context/auth"
import { ModalComponent } from "../modal"
import { MdError, MdWarning } from "react-icons/md"
import { FaRegCheckCircle } from "react-icons/fa"

export const ModalError = () => {
    const { openModalError, errorMessage, handleModal } = useAuth()
    return (
        <ModalComponent
            open={openModalError}
            onClose={() => {
                handleModal(false)
                if (errorMessage?.callback) {
                    errorMessage?.callback()
                }
            }}
        >

            <Grid display={"flex"} alignItems={"center"} justifyContent={"center"} direction={"column"} mt={"-1rem"}>
                {errorMessage?.type === "error" && <MdError color={"red"} size={60}/>}
                {errorMessage?.type === "success" && <FaRegCheckCircle color={"green"} size={60}/>}
                {errorMessage?.type === "warning" && <MdWarning color={"orange"} size={60}/>}
                <Typography fontWeight={700} fontSize={"1.6rem"} maxWidth={"90%"} color={errorMessage?.type ?? "error"} mt={"2.5rem"} textAlign={"center"}>{errorMessage?.message}</Typography>
            </Grid>
        </ModalComponent>
    )
}